import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CONFIG } from '../../config';


@Injectable()
export class UtilsService {
  private config = CONFIG;

  constructor(
  ) {
  }

  public isObjectOnList(obj: object, list: Array<any>, key?: string) {
    let found = false;
    key = key || 'id';

    for (const item of list) {
      if (item[key] === obj[key]) {
        found = true;
      }
    }

    return found;
  }

  public getUUID() {
    return new Date().getTime();
  }

  public generateParams(params: any): HttpParams {
    let httpParams: HttpParams = new HttpParams();

    for (const key in params) {
      if (params[key] instanceof Array) {
        for (const value in params[key]) {  /* eslint-disable-line guard-for-in */
          httpParams = httpParams.append(key, params[key][value]);
        }
      } else {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return httpParams;
  }

  public getAPIPath(): string {
    return this.config.apiUrl;
  }

  public windowBelowBreakpoint(): boolean {
    return document.documentElement.clientWidth < 768;
  }

  public isSortedAscending<T>(arr: Array<T>, comparator?: (a: T, b: T) => number): boolean {
    if (arr.length <= 1) {
      return true;
    }

    const compare = comparator || ((a, b) => (a < b ? -1 : a > b ? 1 : 0));

    for (let i = 0; i < arr.length - 1; i++) {
      if (compare(arr[i], arr[i + 1]) > 0) {
        return false;
      }
    }
    return true;
  }

  public isSortedDescending<T>(arr: Array<T>, comparator?: (a: T, b: T) => number): boolean {
    if (arr.length <= 1) {
      return true;
    }

    const compare = comparator || ((a, b) => (a < b ? -1 : a > b ? 1 : 0));

    for (let i = 0; i < arr.length - 1; i++) {
      if (compare(arr[i], arr[i + 1]) < 0) {
        return false;
      }
    }
    return true;
  }

}
